const { io } = require("socket.io-client");
const connection = io(`${location.protocol}//${location.hostname}:4010`);

module.exports = {
	connection
}
